import { render, staticRenderFns } from "./InvitationCode.vue?vue&type=template&id=2b2b2296&scoped=true"
import script from "./InvitationCode.vue?vue&type=script&lang=js"
export * from "./InvitationCode.vue?vue&type=script&lang=js"
import style0 from "./InvitationCode.vue?vue&type=style&index=0&id=2b2b2296&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b2296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b2b2296')) {
      api.createRecord('2b2b2296', component.options)
    } else {
      api.reload('2b2b2296', component.options)
    }
    module.hot.accept("./InvitationCode.vue?vue&type=template&id=2b2b2296&scoped=true", function () {
      api.rerender('2b2b2296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/InvitationCode.vue"
export default component.exports